import CryptoJS from "crypto-js";

// export function encryptData(text) {
//   var KEY = "12345678900000001234567890000000";
//   var IV = "1234567890000000"; //16 bits
//   var key = CryptoJS.enc.Utf8.parse(KEY);
//   var iv = CryptoJS.enc.Utf8.parse(IV);

//   var encrypted = "";

//   var srcs = CryptoJS.enc.Utf8.parse(text);
//   encrypted = CryptoJS.AES.encrypt(srcs, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   });

//   return encrypted.ciphertext.toString();
// }
export const encryptData = (text) => {
  var secretKey = "12345678900000001234567890000000"; //32 bit
  return CryptoJS.AES.encrypt(text, secretKey).toString();
};

 export const handleEncode = (input) => {
    const utf8Bytes = new TextEncoder().encode(input);
    return btoa(String.fromCharCode(...utf8Bytes));
  };

export const decryptData = (cipherText) => {
  var secretKey = "12345678900000001234567890000000"; //32 bit
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};

// export function decryptData(text) {
//   var KEY = "12345678900000001234567890000000"; //32 bit
//   var IV = "1234567890000000"; //16 bits
//   var key = CryptoJS.enc.Utf8.parse(KEY);
//   var iv = CryptoJS.enc.Utf8.parse(IV);

//   var decrypted = "";

//   var srcs = CryptoJS.enc.Utf8.parse(text);
//   decrypted = CryptoJS.AES.decrypt(srcs, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   });

//   return decrypted?.ciphertext?.toString();
// }
